
import { ReactNode, useEffect, useState } from "react";
import { Dialog } from "../Dialog";
import { Padder, SimpleButton, SimpleContainer, SimplePageTemplate } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { useOrganization } from "../../../biz/hooks/entities/useOrganization";
import { DefaultBanner } from "./SimpleAds";
import { ReadMoreDialog } from "./ReadMoreDialog";
import { useTranslation } from "react-i18next";
import { useAppData } from "../../../biz/data/useAppData";
import { QRCodeSVG } from "qrcode.react";
import { useFetch } from "../../../biz/hooks/data/useFetcher";

export const SimpleAppTools = () => {

    const { t } = useTranslation();
    const ui = useSimpleAppTools();



    return (
        <div className="app-tools">

            <SimplePageTemplate>

                <div className="flex-gap-32">

                    <h1>
                        Skaffa appen och logga in
                    </h1>

                    <StepItem number={"1"} header={"Hämta och installera appen gratis"}>
                        <div className="btns">
                            <SimpleButton
                                onClick={() => { ui.setPhoneType("android"); }}
                                label={"för Android"}
                                type="secondarybeige30"
                                icon="playstore"
                            />

                            <SimpleButton
                                onClick={() => { ui.setPhoneType("ios"); }}
                                label={"för iPhone"}
                                type="secondarybeige30"
                                icon="appstore"
                            />

                            {!!ui.appUrl?.url && (
                                <div>
                                    <QRCodeSVG
                                        value={ui.appUrl.url}
                                        title={ui.appUrl.name}
                                        size={128}
                                        bgColor={"#ffffff"}
                                        fgColor={"#4e3d24"}
                                        level={"M"}
                                    />
                                    <div className="appsore-name">
                                        {ui.appUrl.name}
                                    </div>
                                </div>
                            )}
                        </div>
                    </StepItem>

                    <StepItem number={"2"} header={"Logga in på telefonen "}>
                        <div className="btns">
                            <div className="flex-gap-32">
                                <SimpleButton
                                    onClick={ui.generateLink}
                                    label={"Skapa login länk"}
                                    type={"secondarybeige30"}
                                    icon={"external_link"}
                                    shape="bigpill"
                                    fullWidth={true}
                                />

                                {!!ui.loginUrl && (
                                    <div>
                                        <SimpleButton
                                            onClick={ui.generateLink}
                                            label={"Skapa ny länk"}
                                            type={"secondarybeige30"}
                                            icon={"rotate"}
                                            shape="bigpill"
                                            fullWidth={true}
                                        />
                                    </div>
                                )}
                            </div>

                            {!!ui.loginUrl && (
                                <div style={{ alignItems: "anchor-center;" }} data-url={ui.loginUrl}>

                                    <QRCodeSVG
                                        value={ui.loginUrl}
                                        title={"Logga in"}
                                        size={148}
                                        bgColor={"#ffffff"}
                                        fgColor={"#4e3d24"}
                                        level={"M"}
                                    />
                                </div>
                            )}


                        </div>

                    </StepItem>

                </div>

            </SimplePageTemplate>

            <Padder heightPx={48} />
        </div>
    )
}
const StepItem = ({ number, header, children }: { number: string, header: string, children?: ReactNode }) => {

    return (
        <div className="step-item">
            <div className="number">{number}</div>
            <div className="content">
                <div className="header">{header}</div>
                {children}
            </div>
        </div>
    )
}


type PhoneType = "none" | "ios" | "android";
const useSimpleAppTools = () => {


    const appData = useAppData();
    const org = useOrganization();
    const api = useSimpleAppToolsApi();

    const [phoneType, setPhoneType] = useState<PhoneType>("none");
    const [loginUrl, setLoginUrl] = useState<string>("");

    const appUrl = phoneType === "ios" ? { url: appData.appStoreLink, name: "App store" } :
        phoneType === "android" ? { url: appData.playStoreLink, name: "Playstore" } :
            undefined;

    return {
        appUrl: appUrl,

        phoneType: phoneType,
        setPhoneType: (e: PhoneType) => {
            setPhoneType(phoneType === e ? "none" : e);
            setLoginUrl("");
        }, //setPhoneType,

        loginUrl: loginUrl,

        generateLink: async () => {
            setPhoneType("none");
            const token = await api.generateToken();
            setLoginUrl(appData.getAppLoginLink(token));
        }
    }
}

const useSimpleAppToolsApi = () => {
    const f = useFetch();
    return {
        generateToken: async (): Promise<string> => {
            const url = "/api/accountactions/getnewtoken"
            const { success, token } = await f.patch(url);
            return (success === true) ? token : "";
        }
    }
}